import React from "react";
import './section4.css';
import testeVideo1 from '../../assets/videos/testeVideo3.mp4';

const Section4 = () => {
  return (
    <section className="section4">
      <div className="section4-video-wrapper">
        <video 
          className="section4-video"
          src={testeVideo1}
          autoPlay
          loop
          muted
          playsInline
        >
          Seu navegador não suporta o elemento de vídeo.
        </video>
      </div>
    </section>
  );
};

export default Section4;
